import type { PermissionConfig } from '@openx/utils/permission/context/PermissionContext.tsx';
import { useAclInfo } from './utils/useAclInfo.ts';
import { useExchangeSession } from './utils/useExchangeSession.ts';
import { useIsAllowed } from './utils/useIsAllowed.ts';
import { useMatchesOrganizationType } from './utils/useMatchesOrganizationType.ts';

export const permissionConfig: PermissionConfig = {
  useAclInfo,
  useIsAllowed,
  useMatchesOrganizationType,
  useSession: useExchangeSession,
};
